import React, { Component } from 'react';
import { ShoppingCart32 } from '@carbon/icons-react';
import axios from "axios";
import Slider from "react-slick";

export default class ProductItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
      backgroundColor: '#9BBF65', // Unikatum green as default color
      showAddedToCartHint: false,
      sliderSettings: {
        adaptiveHeight: false,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    }
  }

  componentDidMount() {
    let backgroundColorField = this.props.product.fieldBackgroundColor

    if (backgroundColorField !== null && 'color' in backgroundColorField) {
      this.setState({
        backgroundColor: backgroundColorField.color
      });
    }
  }

  submitToCart = () => {
    let FormData = {
      quantity: this.state.quantity,
      purchased_entity_id: this.props.product.entityId,
      purchased_entity_type: 'commerce_product_variation',
    }

    axios({
      method: 'post',
      url: '/cart/add?_format=json',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.personalToken
      },
      data: JSON.stringify([FormData])
    })
      .then(() => {
        this.showAddToCart();
      })
  }


  showAddToCart = () => {
    this.setState({
      showAddedToCartHint: true
    }, () => {
      setTimeout(() => {
        this.setState({ showAddedToCartHint: false })
      }, 10000)
    })
  }

  render() {
    if (this.props.product) {
      return (
        <div className="product-item" style={{ backgroundColor: this.state.backgroundColor }}>
          <div className="mb-4">
            <strong>{this.props.product.entityLabel}</strong>

            {this.props.product.fieldImages.length > 0 &&
              <div className="mt-2 mb-5">
                <Slider {...this.state.sliderSettings}>
                  {this.props.product.fieldImages.map((image, y) =>
                    <img key={y} src={image.entity.fieldMediaImage.url} />
                  )}
                </Slider>
              </div>
            }

            {this.props.product.fieldDescription &&
              <small dangerouslySetInnerHTML={{ __html: this.props.product.fieldDescription.processed }} />
            }
          </div>
          <div className="mb-4">{this.props.product.price.formatted}</div>
          <div className="mb-4">
            <input className="form-control d-inline" type="number" min="1" max="100" step="1" value={this.state.quantity} onChange={(e) => {this.setState({quantity: e.target.value})}}/>
          </div>
          <button className="btn btn-bordered-white btn-with-icon" onClick={this.submitToCart}>
            <ShoppingCart32/>
            in den Warenkorb
          </button>
          {this.state.showAddedToCartHint &&
            <>
              <div className="mt-5 mb-3">{this.props.product.entityLabel} wurde in den Warenkorb gelegt</div>
              <a href="/cart" className="btn btn-cta">» zum Warenkorb</a>
            </>
          }
        </div>
      );
    } else {
      return null;
    }
  }
}
